// DateTimePicker/utils.ts

export interface DateOption {
  label: string
  value: string
}

export interface NumberOption {
  label: string
  value: number
}

export interface DateTimeValue {
  day: string // YYYY-MM-DD
  hour: number
  minute: number
  utc: string
}

export const toMs = (date: Date | number | string) => {
  if (date instanceof Date) {
    return date.getTime()
  }

  return new Date(date).getTime()
}

export function combineToUTC(isoDate: string, hour: number, minute: number): string {
  const [year, month, day] = isoDate.split('-').map(Number)

  const localDate = new Date(year!, month! - 1, day, hour, minute, 0, 0)

  return localDate.toISOString()
}

export function combineToLocalDate(isoDate: string, hour: number, minute: number): string {
  return `${isoDate}T${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:00.000Z`
}

export function toFarsiNum(value: number, digits = 2): string {
  return value.toLocaleString('fa-IR', {
    minimumIntegerDigits: digits,
    useGrouping: false,
  })
}

export function formatDate(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export function getThreeDays(): DateOption[] {
  const labels = ['امروز', 'فردا', 'پس‌فردا']

  const today = new Date()

  return labels.map((label, index) => {
    const date = new Date(today)

    date.setHours(0, 0, 0, 0)
    date.setDate(today.getDate() + index)

    return {
      label,
      value: formatDate(date),
    }
  })
}

export const DAYS = getThreeDays()

export const HOURS: NumberOption[] = Array.from({ length: 24 }, (_, index) => ({
  label: toFarsiNum(index),
  value: index,
}))

export const MINUTES: NumberOption[] = Array.from({ length: 60 }, (_, index) => ({
  label: toFarsiNum(index),
  value: index,
}))

export function getIndexByValue<T>(items: T[], predicate: (item: T) => boolean): number {
  const index = items.findIndex(predicate)

  return index >= 0 ? index : 0
}
